import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { STUDIO_PRODUCTS_CATALOG_CARD_E_REAL_ESTATE_ID } from '../constants';

export interface Props {}

const StudioProductsCatalogCardE: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId={STUDIO_PRODUCTS_CATALOG_CARD_E_REAL_ESTATE_ID}
  />
);
StudioProductsCatalogCardE.displayName = 'StudioProductsCatalogCardE';

export default StudioProductsCatalogCardE;
